import { ListSuperadminRecordingAnalyticsResponseSchema } from './list-superadmin-recording-analytics.schema';
/**
 * Superadmin Recording-Time Analytics Endpoint Contract
 * A two-level drill-down over active recording time (the heartbeat-tracked
 * editing effort): a per-tenant rollup by default, or per-process rows with
 * their step recordings when scoped to a single tenant. Super-admin only.
 */ export const listSuperadminRecordingAnalyticsContract = {
    method: 'GET',
    path: '/api/v2/superadmin-recording-analytics',
    description: 'Average active recording time per process across tenants (super-admin only)',
    responseSchema: ListSuperadminRecordingAnalyticsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=list-superadmin-recording-analytics.contract.js.map